import { render, staticRenderFns } from "./OrderClaimModal.vue?vue&type=template&id=0b221a58&"
import script from "./OrderClaimModal.vue?vue&type=script&lang=js&"
export * from "./OrderClaimModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports